import React, { useContext } from 'react'
import { FormContext } from '../FormContext';
import Element from './elements/Element'
import './Part.css';
const Part = ({ part: { part_label, fields }, part_id, page_description_index = null, page_user = null, page_type = null ,custom_at_user=false }) => {
    const { formAdmin, formOfficer, formApprovalIndex, formUserLock } = useContext(FormContext);
    
    //console.log('formLockUser',formUserLock)
    const official_status = fields.filter(field => field.field_id?.startsWith('official_status_'))[0]?.field_id?.slice(-1)
 
    return (
        <>
            {part_label && <div className={`form-group col-sm-12 ${(part_id !== 0 && !(formAdmin && (part_id === page_description_index))) ? "pt-4" : ""}`}>
                <h4>{part_label}</h4>
            </div>}

            {fields.length > 0 && fields.map((field, i) => {
                const previousField = fields[i - 1];
                const startsRepeatedGroup = Number(field.field_multiple_index) > 1 &&
                    previousField?.field_multiple_id === field.field_multiple_id &&
                    Number(previousField.field_multiple_index) !== Number(field.field_multiple_index);

                return (
                    <React.Fragment key={field.field_id || i}>
                        {startsRepeatedGroup && <div className="repeat-group-separator" aria-hidden="true" />}
                        <Element
                            field={field}
                            custom_at_user={custom_at_user}
                            isPageUser={(page_user === formOfficer || (!page_user && !formUserLock)) && (formApprovalIndex == official_status || official_status == undefined)}
                        />
                    </React.Fragment>
                );
            })}
        </>
    )
}

export default Part
